export const pos = {
  seo: {
    title: 'Système de caisse pour restaurants | Bistroo',
    description: "Caisse Bistroo quick-service : un système de caisse moderne et ultra-rapide pour restaurants avec paiement par carte, imprimante cloud et intégration directe de vos commandes en ligne.",
  },
  hero: {
    title: {
      pt1: 'Une',
      pt2: 'caisse',
      pt3: 'qui encaisse à une vitesse éclair',
    },
    description:
      'Le Bistroo POS est conçu pour les restaurants de service rapide qui ont besoin de rapidité et de clarté. Commander, traiter et encaisser. Tout depuis un seul système intuitif.',
  },
  paragraphs: {
    paragraph_1: {
      title: 'Commander et encaisser n\'a jamais été aussi simple',
      text: 'Le Bistroo POS traite les commandes à une vitesse éclair. L\'interface claire est conçue pour les périodes de pointe : sélection rapide des options, confirmation immédiate et encaissement en un flux fluide. Vos files d\'attente restent courtes, vos clients satisfaits.',
      cta: 'Explorer les formules Bistroo',
    },
    paragraph_2: {
      title: 'Accessible sans engagement',
      text: 'Il suffit de brancher et de démarrer, pas d\'installations complexes ni de configuration compliquée comme avec les systèmes de caisse traditionnels. À partir de seulement 15 € par mois, vous avez accès à un système de caisse moderne conçu pour les restaurants de service rapide. Pas de contrats à long terme, pas de frais cachés.',
      cta: '',
    },
    paragraph_3: {
      title: 'Tickets cuisine et client imprimés automatiquement',
      text: 'Chaque commande imprime automatiquement le bon ticket pour la cuisine et le client. Définissez exactement ce qui apparaît sur chaque ticket. Grâce à l\'intégration transparente avec votre imprimante cuisine, votre flux de travail fonctionne toujours sans accroc, même pendant les périodes les plus chargées.',
      cta: 'Explorer les formules Bistroo',
    },
    paragraph_4: {
      title: 'Gestion complète via le Bistroo Manager',
      text: 'Gérez votre menu, vos horaires d\'ouverture, vos employés et vos rapports depuis le Bistroo Manager. Consultez votre chiffre d\'affaires journalier, clôturez votre service avec un rapport Z et suivez tout sans logiciel supplémentaire. Un seul système pour l\'ensemble de votre exploitation.',
      cta: '',
    },
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Saisie rapide des commandes.',
        text: 'Entrez les commandes à toute vitesse avec des options et des variantes claires. Conçu pour le rythme d\'un restaurant de service rapide.',
        button: '',
        img_alt: '',
      },
      card_2: {
        title: 'Plusieurs modes de paiement.',
        text: 'Acceptez le PIN, le sans contact et les paiements partagés. Un encaissement flexible pour chaque situation.',
        button: '',
        img_alt: '',
      },
      card_3: {
        title: 'Tickets cuisine et client.',
        text: 'Impression automatique du ticket à chaque commande, aussi bien pour la cuisine que pour le client.',
        button: '',
        img_alt: '',
      },
      card_4: {
        title: 'Clôture de service et de journée.',
        text: 'Clôturez facilement votre service ou votre journée avec un rapport Z complet. Toujours une vue d\'ensemble de vos performances.',
        button: '',
        img_alt: '',
      },
      card_5: {
        title: 'Plug-and-play.',
        text: 'Opérationnel en quelques minutes. Aucune connaissance technique requise — il suffit d\'allumer et de commencer.',
        button: '',
        img_alt: '',
      },
    },
  },
  testimonial: {
    text: '"Avec le Bistroo POS, nos commandes vont beaucoup plus vite. Lors du pic du déjeuner, nous traitons maintenant deux fois plus de clients qu\'avant — sans stress."',
    cta: 'Lire l\'histoire complète',
    name: 'Sander de Vries',
    job_title: 'Propriétaire Quick Bites',
  },
  faq: {
    title_pt1: 'Tout sur le',
    title_pt2: 'système de caisse Bistroo',
    items: [
      { q: 'Qu\'est-ce que le système de caisse Bistroo POS ?', a: 'Le Bistroo POS est un système de caisse moderne spécialement conçu pour les restaurants de service rapide. Via une interface tactile claire, vous traitez les commandes à grande vitesse, acceptez plusieurs modes de paiement et imprimez automatiquement les tickets.' },
      { q: 'Combien de temps faut-il pour démarrer avec le Bistroo POS ?', a: 'Le Bistroo POS est opérationnel en quelques minutes. Pas d\'installation complexe, aucune connaissance technique requise. Allumez et commencez.' },
      { q: 'Quels modes de paiement le Bistroo POS accepte-t-il ?', a: 'Le POS accepte le paiement par carte (sans contact et puce), Apple Pay et Google Pay. Les paiements partagés sont également possibles, afin qu\'un groupe de clients puisse facilement diviser l\'addition.' },
      { q: 'Les commandes sont-elles automatiquement imprimées ?', a: 'Oui. Chaque commande imprime automatiquement le bon ticket pour la cuisine et le client. Vous définissez vous-même ce qui apparaît sur chaque ticket et quelle imprimante reçoit quel ticket.' },
      { q: 'Qu\'est-ce qu\'un rapport Z et comment l\'utiliser ?', a: 'Un rapport Z est une clôture journalière de la caisse indiquant l\'ensemble du chiffre d\'affaires et des transactions du service. Via le Bistroo POS, vous générez le rapport Z en un seul clic à la fin de chaque service.' },
      { q: 'Puis-je connecter le POS à ma boutique Bistroo ?', a: 'Oui. Le Bistroo POS est entièrement intégré à la boutique en ligne, à la borne de commande et à la commande QR à table. Toutes les commandes de tous les canaux convergent dans un seul système clair.' },
      { q: 'Quel matériel est nécessaire pour le Bistroo POS ?', a: 'Vous avez besoin d\'une tablette ou d\'un appareil à écran tactile plus d\'une imprimante à tickets. Bistroo fournit également une configuration matérielle complète. Contactez-nous pour un conseil personnalisé.' },
      { q: 'Comment modifier mon menu via le POS ?', a: 'Les modifications de menu s\'effectuent via l\'application Bistroo Manager, sur n\'importe quel appareil. Les modifications sont immédiatement visibles sur le POS, la boutique en ligne et les éventuelles bornes.' },
      { q: 'Quel est le coût du Bistroo POS ?', a: 'Le Bistroo POS est disponible à partir de 15 € par mois. Pas de contrats à long terme et pas de frais cachés. Vous ne payez que ce que vous utilisez.' },
      { q: 'Puis-je gérer plusieurs employés avec le Bistroo POS ?', a: 'Oui. Vous créez des identifiants employés séparés afin de toujours savoir qui a saisi quelle commande. Pratique pour les rapports de service et la gestion du personnel.' },
    ],
  },
}
